import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import { Switch } from '@headlessui/react'
import { setInjuries } from "redux/slices/generator"

export default function InjuriesInputContainerGenerator() {
    const dispatch = useDispatch()
    const injuries = useSelector((state) => state.generator.inputs.injuries) || []
    const selectedInjury = injuries.length > 0 ? injuries[0] : null

    const [detailsExpanded, setDetailsExpanded] = useState(false)

    const handleInjuryToggle = (injuryType) => {
        const newInjuries = selectedInjury === injuryType ? [] : [injuryType]
        dispatch(setInjuries(newInjuries))
    }

    return (
        <div className="bg-white border border-gray-400 p-4 rounded-xl space-y-6">
            <div
                className='flex items-center cursor-pointer gap-x-4'
                onClick={() => setDetailsExpanded(!detailsExpanded)}
            >
                <div className={'flex-grow'}>Injuries</div>
                {!detailsExpanded && <ChevronDownIcon className='w-6 h-6 text-gray-400' />}
                {detailsExpanded && <ChevronUpIcon className='w-6 h-6 text-gray-400' />}
            </div>

            {detailsExpanded &&
                <div className='space-y-4 p-4 bg-gray-50 rounded-lg'>
                    <div className="space-y-4">
                        <div className="flex items-center justify-between">
                            <span className="text-gray-700">Patellar Tendon</span>
                            <Switch
                                checked={selectedInjury === 'patellar-tendon'}
                                onChange={() => handleInjuryToggle('patellar-tendon')}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2
                                    ${selectedInjury === 'patellar-tendon' ? 'bg-orange-600' : 'bg-gray-200'}
                                `}
                            >
                                <span className="sr-only">Patellar Tendon Injury</span>
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${selectedInjury === 'patellar-tendon' ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>
                        </div>

                        <div className="flex items-center justify-between">
                            <span className="text-gray-700">Achilles Tendon</span>
                            <Switch
                                checked={selectedInjury === 'achilles-tendon'}
                                onChange={() => handleInjuryToggle('achilles-tendon')}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2
                                    ${selectedInjury === 'achilles-tendon' ? 'bg-orange-600' : 'bg-gray-200'}
                                `}
                            >
                                <span className="sr-only">Achilles Tendon Injury</span>
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${selectedInjury === 'achilles-tendon' ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>
                        </div>

                        <div className="flex items-center justify-between">
                            <span className="text-gray-700">Bone Stress Injury</span>
                            <Switch
                                checked={selectedInjury === 'bone-stress'}
                                onChange={() => handleInjuryToggle('bone-stress')}
                                className={`
                                    relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2
                                    ${selectedInjury === 'bone-stress' ? 'bg-orange-600' : 'bg-gray-200'}
                                `}
                            >
                                <span className="sr-only">Bone Stress Injury</span>
                                <span
                                    aria-hidden="true"
                                    className={`
                                        pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                        ${selectedInjury === 'bone-stress' ? 'translate-x-5' : 'translate-x-0'}
                                    `}
                                />
                            </Switch>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
} 